import { PuzzleVideo, PuzzleUserAnswer } from '@/types/Puzzle'

export const puzzle: PuzzleVideo[] = [
  {
    id: 1,
    poster: require('@/assets/png/puzzle-video-poster-1.png'),
    dataVideoId: 'puzzle.dataVideosId.1',
  },
  {
    id: 2,
    poster: require('@/assets/png/puzzle-video-poster-2.png'),
    dataVideoId: 'puzzle.dataVideosId.2',
  },
  {
    id: 3,
    poster: require('@/assets/png/puzzle-video-poster-3.png'),
    dataVideoId: 'puzzle.dataVideosId.3',
  },
  {
    id: 4,
    poster: require('@/assets/png/puzzle-video-poster-4.png'),
    dataVideoId: 'puzzle.dataVideosId.4',
  },
]

export const puzzleCorrectAnswers: PuzzleUserAnswer[] = [
  {
    stepId: 1,
    videoId: 2,
  },
  {
    stepId: 2,
    videoId: 4,
  },
  {
    stepId: 3,
    videoId: 1,
  },
  {
    stepId: 4,
    videoId: 3,
  },
]

export const puzzleReferences: { [key: string]: string } = {
  1: `Cosnes J, Cattan S, Blain A, et al. Long-term evolution of disease behavior of Crohn's disease. Inflamm Bowel Dis. 2002;8:244–50.2.`,
  2: `Isene R, et al. Extraintestinal manifestations in Crohn's disease and ulcerative colitis: results from a prospective, population-based European inception cohort. Scan J Gastroenterol 2015;50:300–5.`,
  3: `Vavricka SR, et al. Chronological order of appearance of extraintestinal manifestations relative to the time of IBD diagnosis in the Swiss Inflammatory Bowel Disease Cohort. Inflamm Bowel Dis 2015;21:1794–800.`,
  4: 'Neurath MF. Targeting immune cell circuits and trafficking in inflammatory bowel disease. Nat Immunol. 2019;20:970–9.',
  5: 'Thia KT, Sandborn WJ, Harmsen WS, et al. Risk factors associated with progression to intestinal complications of Crohn’s disease in a population-based cohort. Gastroenterology. 2010;139:1147–55.',
  6: 'Lovasz BD, Lakatos L, Horvath A, et al. Evolution of disease phenotype in adult and pediatric onset Crohn’s disease in a population-based cohort. World J Gastroenterol. 2013;19:2217–26.',
  7: `Pariente P, et al. Development of the Crohn's disease digestive damage score, the Lémann score. Inflamm Bowel Dis. 2011 Jun;17(6):1415-22.`,
  8: `Ungaro RC, Aggarwal S, Topaloglu O, et al. Systematic review and meta-analysis: efficacy and safety of early biologic treatment in adult and paediatric patients with Crohn's disease. Aliment Pharmacol Ther 2020;51:831-42.`,
  9: 'Habtezion A, Nguyen LP, Hadeiba H, et al. Leukocyte trafficking to the small intestine and colon. Gastroenterology. 2016;150:340–54.',
  10: 'Carman CV, Martinelli R. T Lymphocyte–endothelial interactions: emerging understanding of trafficking and antigen-specific immunity. Front Immunol. 2015;6:603.',
  11: 'Zundler S, Becker E, Schulze LL, et al. Immune cell trafficking and retention in inflammatory bowel disease: mechanistic insights and therapeutic advances. Gut. 2019;68:1688–700.',
  12: 'Eksteen B, Liaskou E, Adams DH. Lymphocyte homing and its role in the pathogenesis of IBD. Inflamm Bowel Dis. 2008;14:1298–312.',
  13: 'Arseneau KO, Cominelli F. Targeting leukocyte trafficking for the treatment of inflammatory bowel disease. Clin Pharmacol Ther. 2015;97:22–8.',
  14: 'Neurath MF. Targeting immune cell circuits and trafficking in inflammatory bowel disease. Nat Immunol. 2019;20:970–9.',
  15: 'Neurath MF.  Cytokines in inflammatory bowel disease. Nature Reviews Immunology. 2014; 14: 329-342',
  16: 'Allez M.  CD4NKG2D+ T cells in Crohn’s disease mediate inflammatory and cytotoxic responses through MICA interactions. Gastroenterology. 2007; 132:2346-2358',
  17: `Boschetti G.  Enrichment of circulating and mucosal cytotoxic CD8+ T cells is associated with postoperative endoscopic recurrence in patients with crohn’s disease. Journal of Crohn's and Colitis. 2016; 338–345`,
  18: 'Silva FA, Rodrigues BL, Ayrizono ML, et al. The immunological basis of inflammatory bowel disease. Gastroenterol Res Pract. 2016;2016:2097274',
  19: 'Arijs I, De Hertogh G, Lemmens B, et al. Effect of vedolizumab (anti-α4β7-integrin) therapy on histological healing and mucosal gene expression in patients with UC. Gut. 2018;67:43–52',
}
